import { Injectable } from '@angular/core';

import { ErrorQuery } from './error.query';
import { ErrorStore } from './error.store';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  constructor(public query: ErrorQuery, public store: ErrorStore) { }
}
